import DeleteMembershipPlan from "./DeleteMembershipPlan";

export default DeleteMembershipPlan